export default {
	path: '/tree-view',
	redirect: '/tree-view',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'treeViewHome',
			component: () => import('@/views/mng/TreeView'),
		},
	],
};
